<template>
  <!-- CCS_92037 nur über App buchbar. Kann ab dem 27.12.2021 wieder ausgebaut werden   -->
  <div class="app-tariff-options-list">
    <div v-if='isBoxView'>
      <div v-for="option in options" :key="option.key" :class="option.tariffoptionId">
        <TariffOptionsBox
          v-if='isTariff && (option.tariffoptionId !=="CCS_92037" || ccs92037 === "show")'
          :option="option"
          :clicked="clicked"
          @details="detailsAction"
        >
        </TariffOptionsBox>
        <ServiceOptionsBox
          :option="option"
          :clicked="clicked"
          v-if='isService'
          @details="detailsAction"
        >
        </ServiceOptionsBox>
      </div>
    </div>
    <div v-if='isListView'>
      <div v-for="option in options" :key="option.key" :class="option.tariffoptionId">
        <TariffSmallListElement
          v-if='isTariff && (option.tariffoptionId !=="CCS_92037" || ccs92037 === "show")'
          :option="option"
          :current-tariff-id=currentTariffId
          :clicked="clicked"
          @details="detailsAction"
        >
          <template v-for="slot in possibleChildSlotsFor('ListElement')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </TariffSmallListElement>
        <TariffSmallListElement
          :option="option"
          :current-tariff-id=currentTariffId
          :clicked="clicked"
          :is-service="true"
          v-if='isService'
          @details="detailsAction"
        >
          <template v-for="slot in possibleChildSlotsFor('ListElement')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </TariffSmallListElement>
      </div>
    </div>
  </div>
</template>
<script>

import TariffOptionsBox from '@/components/process/generic/Tariff/generic/TariffOptions/TariffOptionsBoxWrapper.vue'
import ServiceOptionsBox from '@/components/process/generic/Tariff/generic/ServiceOptions/ServiceOptionsBoxWrapper.vue'
import TariffSmallListElement from '@/components/process/generic/Tariff/generic/TariffOptions/TariffSmallListElement.vue'
import slotProxy from '@/mixins/slotProxy'
export default {
  name: 'TariffOptionsList',
  components: { TariffSmallListElement, TariffOptionsBox, ServiceOptionsBox },
  methods: {
    detailsAction (option) {
      this.$emit('details', option)
    }
  },
  computed: {
    isBoxView: function () {
      return (this.view === 'box')
    },
    isListView: function () {
      return (this.view === 'list')
    },
    isTariff: function () {
      return (this.type === 'tariff')
    },
    isService: function () {
      return (this.type === 'service')
    }
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    view: {
      type: String,
      default: 'box'
    },
    type: {
      type: String,
      default: 'tariff'
    },
    currentTariffId: {
      type: String,
      default: '82'
    },
    clicked: {
      type: Array,
      default: () => []
    },
    ccs92037: {
      type: String,
      default: 'hidden'
    }
  },
  mixins: [
    slotProxy()
  ]
}
</script>
